import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(3),
    width: "100%",
  },
  link: {
    color: "#4187B6",
    textDecoration: "none",
    marginBottom: theme.spacing(2),
  },
}));
